import React, { useContext } from 'react'
import { ProjectContext } from '../../context/ProjectContext'
import OverviewIcon from '../icons/Overview'
import MeetingsIcon from '../icons/Meetings'
import NeedsIcon from '../icons/Needs'
import ProblemsIcon from '../icons/Problems'
import QASIcon from '../icons/QAS'
import FeedbackIcon from '../icons/Feedback'
import TranscriptsIcon from '../icons/Transcripts'
import QuotesIcon from '../icons/Quotes'
import { cn } from '@/lib/utils'
import { Badge } from '@/components/ui/badge'

interface NavigationItem {
  label: string
  value: string
  icon: React.ComponentType<{ checked?: boolean }>
  count?: number
}

export function ProjectNavigation() {
  const {
    setScrollToCategory,
    setScrollToMeeting,
    notes,
    meetings,
    feedbacks,
    overview,
    menu,
    setMenu,
    quotes,
    problems,
    setNeedsFilters,
  } = useContext(ProjectContext)

  const navigationItems: NavigationItem[] = [
    {
      label: 'Overview',
      value: 'overview',
      icon: OverviewIcon,
    },
    {
      label: 'Meetings',
      value: 'meetings',
      icon: MeetingsIcon,
      count: meetings.length,
    },
    {
      label: 'Interview',
      value: 'qas',
      icon: QASIcon,
      count: overview?.qas?.length,
    },
    {
      label: 'Quotes',
      value: 'quotes',
      icon: QuotesIcon,
      count: quotes.length,
    },
    {
      label: 'Needs',
      value: 'notes',
      icon: NeedsIcon,
      count: notes.length,
    },
    {
      label: 'Pain Points',
      value: 'problems',
      icon: ProblemsIcon,
      count: problems.length,
    },
    {
      label: 'Feedback',
      value: 'feedbacks',
      icon: FeedbackIcon,
      count: feedbacks.length,
    },
    {
      label: 'Transcripts',
      value: 'transcripts',
      icon: TranscriptsIcon,
      count: meetings.length,
    },
  ]

  const handleTabChange = (value: string) => {
    setScrollToCategory('')
    setScrollToMeeting('')
    
    // Update needsFilters based on the tab
    if (value === 'notes') {
      setNeedsFilters(prev => ({ ...prev, star: 'all' }))
    } else if (value === 'overview') {
      setNeedsFilters(prev => ({ ...prev, star: true }))
    }
    
    setMenu(value)
  }

  return (
    <div className="bg-white w-[75px] h-full flex flex-col items-center border-r border-r-[#e4e4e4] pt-[60px]">
      {navigationItems.map(({ label, value, icon: Icon, count }) => (
        <button
          key={value}
          onClick={() => handleTabChange(value)}
          className={cn(
            'w-full h-[75px] flex flex-col justify-center items-center gap-[9px] group',
            'hover:bg-gray-50 transition-colors'
          )}
        >
          <div className="relative">
            <Icon checked={menu === value} />
            {count !== undefined && (
              <Badge
                variant="secondary"
                className={cn(
                  "absolute -top-1 -right-3 bg-[#3F424A] text-white text-[10px] h-4 px-1 transition-opacity duration-200",
                  menu === value ? "opacity-100" : "opacity-0 group-hover:opacity-100"
                )}
              >
                {count}
              </Badge>
            )}
          </div>
          <p
            className={cn(
              'text-[11px] font-semibold font-["Manrope"] leading-3 tracking-wide',
              menu === value ? 'text-[#FF4A8E]' : 'text-[#3F424A]'
            )}
          >
            {label}
          </p>
        </button>
      ))}
    </div>
  )
} 